import * as React from 'react';
import {connect} from "react-redux";
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {FORM_ACTION_TYPE} from '../../Config/appConfig';
import {Auth} from '../../Config/dataModel';
import authState from '../../ReduxRequests/State/authState';

const createDefault = require('../../resource/img/create-default.svg');
const batchDefault = require('../../resource/img/batch-default.svg');
const createFocused = require('../../resource/img/create-focused.svg');
const batchFocused = require('../../resource/img/batch-focused.svg');

interface RecordsSquareButtonProps {
    auth: () => Auth,
    buttonType: string
}

interface RecordsSquareButtonState {
    isHover: boolean
}

class RecordsSquareButton extends React.Component <RouteComponentProps & RecordsSquareButtonProps, RecordsSquareButtonState, {}> {
    public constructor(props: RecordsSquareButtonProps) {
        super(props);
        this.state = {
           isHover: false
        };
        this.clickBtn = this.clickBtn.bind(this);
    }

    public clickBtn(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        switch (this.props.buttonType) {
            case FORM_ACTION_TYPE.CREATE:
                this.props.history.push('/ui/create');
                break;
            case FORM_ACTION_TYPE.BATCH:
                this.props.history.push('/ui/batch');
                break;
            default:
                break;
        }
    }

    public getResource() {
        let title = '';
        let background = '';
        switch (this.props.buttonType) {
            case FORM_ACTION_TYPE.CREATE:
                title = 'Create';
                background = this.state.isHover ? createFocused : createDefault;
                break;
            case FORM_ACTION_TYPE.BATCH:
                title = 'Batch';
                background = this.state.isHover ? batchFocused : batchDefault;
                break;
            default:
                break;
        }
        return {title, background};
    }

    public setIsHover(isHover: boolean) {
        this.setState({
            isHover
        })
    }

    public render() {
        const resource = this.getResource();
        return (
            <button className={`cmWhiteBtn recordsButton ${this.props.buttonType === FORM_ACTION_TYPE.CREATE ? "recordsSquareButtonCreate" : "recordsSquareButtonBatch"}`} onClick={this.clickBtn} onMouseOver={(e) => this.setIsHover(true)} onMouseOut={(e) => this.setIsHover(false)}>
                <div className="cmHorCenter recordsSquareButtonIcon">
                    <img width="55" height="55" src={resource.background}/>
                </div>
                <div className="cmBoldText recordsSquareButtonTitle">{resource.title}</div>
            </button>
        );
    }
}

export default withRouter(connect(authState, null)(RecordsSquareButton));



// WEBPACK FOOTER //
// ./src/Components/Records/RecordsSquareButton.tsx